import { api } from '../api';
import { AutoscalerBufferSizesDto } from '@repo/common-types/src/dto/k8s/autoscaler-buffer.dto';
import { ReadyGameServersDto } from '@repo/common-types/src/dto/k8s/ready-game-servers.dto';
import {
  RestartAllocatedJobCreatedDto,
  RestartAllocatedJobDto,
} from '@repo/common-types/src/dto/k8s/restart-allocated.dto';

export const startRestartAllocatedGameServers = async (): Promise<RestartAllocatedJobCreatedDto> => {
  const response = await api.post<RestartAllocatedJobCreatedDto>('/v1/admin/game-servers/restart-allocated', {});
  return response.data;
};

export const getRestartAllocatedJob = async (): Promise<RestartAllocatedJobDto> => {
  const response = await api.get<RestartAllocatedJobDto>(`/v1/admin/game-servers/restart-allocated`);
  return response.data;
};

export const getAutoscalerBufferSizes = async (): Promise<AutoscalerBufferSizesDto> => {
  const response = await api.get<AutoscalerBufferSizesDto>(`/v1/admin/game-servers/autoscaler-buffer`);
  return response.data;
};

export const updateAutoscalerBufferSizes = async (
  payload: AutoscalerBufferSizesDto,
): Promise<AutoscalerBufferSizesDto> => {
  const response = await api.put<AutoscalerBufferSizesDto>(`/v1/admin/game-servers/autoscaler-buffer`, payload);
  return response.data;
};

export const getReadyGameServers = async (): Promise<ReadyGameServersDto> => {
  const response = await api.get<ReadyGameServersDto>(`/v1/admin/game-servers/ready`);
  return response.data;
};
